import {t} from 'i18next';
import {Typography} from '@mui/material';
import AurDialog, {DialogProps} from '../../../common/aur-dialog/AurDialog';
import {ReactComponent as InfoAlertIcon} from '../../../../assests/svg/warning-icon.svg';

interface QueryBuilderClearConfirmationAlertProps {
  showDialog: DialogProps['showDialog'];
  onOk: DialogProps['onOk'];
  validationErrorCode: string[];
}

const stringPath = 'overlay.createErrorAlert.';

const CreateOverlayErrorAlert = ({
  showDialog,
  onOk,
  validationErrorCode = [],
}: QueryBuilderClearConfirmationAlertProps) => {
  const renderDynamicContent = () => {
    return (
      <>
        <Typography className="typo-text subhead4_size title-text">
          {t(stringPath + 'fieldHavingIssue')}
        </Typography>
        <Typography className="typo-text body2_size">
          {validationErrorCode.join(', ')}
        </Typography>

        <Typography className="typo-text body2_size title-text mt-16">
          {t(stringPath + 'pleaseUpdate')}
        </Typography>
      </>
    );
  };

  return (
    <AurDialog
      showDialog={showDialog}
      className="create-overlay-error-popup"
      type="alert"
      popupTitle={t(stringPath + 'title')}
      infoIcon={
        <div className="error-icon-container">
          <InfoAlertIcon />
        </div>
      }
      popupContent={renderDynamicContent()}
      labelActionOk={t('buttons.ok')}
      onOk={onOk}
      onCancel={onOk}
      buttonStyle="single"
    />
  );
};

export default CreateOverlayErrorAlert;
